export default __webpack_public_path__ + "static/edit-listing-photos-66b4cb5f44d3619891bbd0a2b0ab9afa.png";